import { useState, useEffect } from "react";
import { Modal, Typography } from "antd";
import FilePicker from "@/components/views/FilePicker";

const { Text } = Typography;

const FileLinkModal = ({
  visible,
  onSave,
  onCancel,
  isAdmins = false,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCompactCatalog, setIsCompactCatalog] = useState(
    window.innerWidth < 960,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsCompactCatalog(window.innerWidth < 960);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSave = async () => {
    setError(null);
    setIsLoading(true);

    const payload = {
      file_uuid: selectedFile.uuid,
      name: selectedFile.name,
      description: selectedFile.description,
      extension: selectedFile.extension,
      original_name: selectedFile.original_name,
    };

    try {
      await onSave(payload);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title="Добавить файл из системы"
      open={visible}
      onOk={handleSave}
      onCancel={() => {
        setSelectedFile(null);
        onCancel?.();
      }}
      okText="Ок"
      cancelText="Отмена"
      okButtonProps={{ disabled: !selectedFile, loading: isLoading }}
      width={1400}
      destroyOnHidden
      style={{ height: "90vh", top: "5vh" }}
      styles={{ body: { overflow: "hidden", height: "calc(90vh - 140px)" } }}
    >
      <FilePicker
        isAdmins={isAdmins}
        isCompactCatalog={isCompactCatalog}
        onSelect={(file) => setSelectedFile(file)}
      />

      {error && (
        <div style={{ marginTop: "20px" }}>
          <Text type="danger">{error}</Text>
        </div>
      )}
    </Modal>
  );
};

export default FileLinkModal;
